(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('Vendor/jquery'), require('Vendor/@openmind/litelog')) :
	typeof define === 'function' && define.amd ? define(['Vendor/jquery', 'Vendor/@openmind/litelog'], factory) :
	(global.StoreLocator = factory(global.$,global.Logger));
}(this, (function ($,Logger) { 'use strict';

$ = $ && $.hasOwnProperty('default') ? $['default'] : $;
Logger = Logger && Logger.hasOwnProperty('default') ? Logger['default'] : Logger;

var Log = new Logger("StoreLocator");
var StoreLocator = function StoreLocator(options) {
    this.options = $.extend(true, {}, this.DefaultOptions, options);
    this.Geocoder = new google.maps.Geocoder();
    this._zoom = 0;
    this.__searchEngines__ = {};
    this.__map_engines__ = {};
    this.__map__ = null;
};

var prototypeAccessors = { DefaultOptions: { configurable: true },Version: { configurable: true },Errors: { configurable: true },AddressType: { configurable: true },SearchEngines: { configurable: true },MapsEngines: { configurable: true },Engines: { configurable: true },Map: { configurable: true },zoom: { configurable: true } };
prototypeAccessors.DefaultOptions.get = function () {
    return {
        Engines: {},
        "markerkey": "storeCode",
        selectors: {
            maps: "",
            searches: ""
        },
        AllowedAddressType: [],
        ShowMapRectangle: false,
        CoreanPercentageSwitch: 25,
        ClusterMaxZoom: 7,
        ClusterMinSize: 3,
        ClusterGridSize: 60,
        searchMinLengh: 3,
        ClusterImagePath: "/images/store-locator-maps/cluster",
        ClusterImageExt: "png",
        Maps: {
            Google: {
                mapTypeControl: false,
                overviewMapControl: false,
                panControl: false,
                scaleControl: false,
                streetViewControl: false,
                scrollwheel: false,
                minZoom: 1,
                maxZoom: 18,
                zoom: 8,
                zoomControl: false,
                gestureHandling: "greedy"
            },
            Naver: {}
        }
    };
};
prototypeAccessors.Version.get = function () {
    return '3.0.0';
};

prototypeAccessors.Errors.get = function () {
    return {
        NO_MAP_FOUND: "NOMAPFOUND",
        NO_ADDRESS_FOUND: "NOADDRESSFOUND",
        NO_GEOLOCATION: "NOGEOLOCATION",
        NO_LOCATION: "NOLOCATION"
    };
};
prototypeAccessors.AddressType.get = function () {
    return {
        Fixed: "_fixed_",
        PointOnMap: "_point_on_map_",
        Generic: "_generic_"
    };
};
prototypeAccessors.SearchEngines.get = function () {
    return this.__searchEngines__;
};
prototypeAccessors.MapsEngines.get = function () {
    return this.__map_engines__;
};
prototypeAccessors.Engines.get = function () {
    return this.options.Engines;
};
prototypeAccessors.Map.get = function () {
    return this.__map__;
};
prototypeAccessors.Map.set = function (m) {
    return this.__map__ = m;
};
StoreLocator.prototype.selectMapEngine = function selectMapEngine (viewport, bounds, zoom) {
    Log.debug("Choose map engine for viewport", viewport, bounds, "zoom:", zoom);
    var map;
    $.each(this.MapsEngines, function (i, eng) {
        if (eng.test(viewport, bounds, zoom)) {
            Log.debug("Map engine found:", i);
            map = eng;
            return false;
        }
    });
    return map;
};
StoreLocator.prototype.search = function search (str, use_bounds) {
        var this$1 = this;

    return new Promise(function (resolve, reject) {
        var all_promises = [];
        $.each(this$1.SearchEngines, function (i, engine) {
            all_promises.push(engine.search(str, use_bounds && this.Map.bounds));
        });
        Promise.all(all_promises).then(function (result) {
            resolve(result);
        });
    });
};
StoreLocator.prototype.currentLocation = function currentLocation (opts) {
        var this$1 = this;

    return new Promise(function (resolve, reject) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (pos) {
                resolve({
                    lat: pos.coords.latitude,
                    lng: pos.coords.longitude,
                    location: pos
                });
            }, function () {
                reject(this$1.Errors.NO_LOCATION);
            }, $.extend(true, {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            }, opts));
        } else {
            reject(this$1.Errors.NO_GEOLOCATION);
        }
    });
};
StoreLocator.prototype.navigate = function navigate (address, location, force_fixed_point) {
        var this$1 = this;

    return new Promise(function (resolve, reject) {
        if (location) {
            if (!(location instanceof google.maps.LatLng)) {
                location = new google.maps.LatLng(location.lat, location.lng);
            }
        }
        this$1.Geocoder.geocode({
            address: address,
            location: location
        }, function (result, status) {
            Log.l("Results", status, result);
            if (status !== google.maps.GeocoderStatus.OK) {
                Log.warn("No results found for", address);
                reject(this$1.Errors.NO_ADDRESS_FOUND);
            } else {
                result = (function () {
                    if (!this$1.options.AllowedAddressType || !this$1.options.AllowedAddressType.length) {
                        return result;
                    }
                    var location = [];
                    for (var i$1 = 0, list$1 = result; i$1 < list$1.length; i$1 += 1) {
                        var l = list$1[i$1];

                            for (var i = 0, list = l.types; i < list.length; i += 1) {
                            var t = list[i];

                                if (this$1.options.AllowedAddressType.indexOf(t) > -1) {
                                location.push(l);
                                break;
                            }
                        }
                    }
                    return location;
                })();
                if (result.length <= 0) {
                    reject(this$1.Errors.NO_ADDRESS_FOUND);
                } else {
                    var bounds = result[0].geometry.viewport || result[0].geometry.bounds;
                    if (!bounds) {
                        Log.warn("Invalid location or bounds", result[0].geometry);
                        return reject(this$1.Errors.NO_ADDRESS_FOUND);
                    }
                    var fixed_point = (function () {
                        if (location || force_fixed_point) {
                            return {
                                lat: result[0].geometry.location.lat(),
                                lng: result[0].geometry.location.lng(),
                                _type: this$1.AddressType.Fixed,
                                bounds: JSON.parse(JSON.stringify(result[0].geometry.viewport))
                            };
                        } else {
                            return {
                                lat: result[0].geometry.location.lat(),
                                lng: result[0].geometry.location.lng(),
                                bounds: JSON.parse(JSON.stringify(result[0].geometry.viewport)),
                                _type: [google.maps.GeocoderLocationType.RANGE_INTERPOLATED,
                                    google.maps.GeocoderLocationType.ROOFTOP].indexOf(result[0].geometry.location_type) > -1 ? this$1.AddressType.PointOnMap : this$1.AddressType.Generic
                            };
                        }
                    })();
                    this$1.trigger("change-address", address || result[0].formatted_address, fixed_point);
                    resolve({
                        bounds: bounds,
                        results: result
                    });
                }
            }
        });
    });
};
StoreLocator.prototype.navigateLocation = function navigateLocation (bounds, zoom) {
        var this$1 = this;

    bounds = JSON.parse(JSON.stringify(bounds));
    return new Promise(function (resolve, reject) {
        Log.log("Navigating to location using", this$1.Map);
        var currentMap = this$1.Map;
        this$1.unbindEventOnMap(currentMap);
        var prev_viewport = currentMap.viewport;
        currentMap.navigate(bounds);
        if (zoom) {
            this$1.zoom = zoom;
        }
        var change_viewport = true;
        if (prev_viewport) {
            change_viewport = !currentMap.Map.getBounds().equals(currentMap.getBoundsFromCoords(prev_viewport));
        }
        Log.debug("Change viewport", change_viewport);
        var execNavigation = function () {
            Log.log("Navigated using", currentMap);
            var viewportBounds = currentMap.bounds;
            var _zoom = this$1.zoom;
            Log.info("Testing map engine for viewport", viewportBounds, "zoom:", _zoom);
            if (this$1.selectAndSwitchMap(viewportBounds, bounds, _zoom)) {
                this$1.trigger("navigateTo", this$1.Map, bounds);
                resolve();
            } else {
                reject(this$1.Errors.NO_MAP_FOUND);
            }
        };
        if (!change_viewport) {
            execNavigation();
        } else {
            var rem_idle_ev = currentMap.on("idle", function () {
                currentMap.off(rem_idle_ev);
                execNavigation();
            });
        }
    });
};
StoreLocator.prototype.expandViewport = function expandViewport (point) {
    var bounds = this.Map.addPointToViewport(point);
    this.navigateLocation(bounds);
};
StoreLocator.prototype.selectAndSwitchMap = function selectAndSwitchMap (viewport, bounds, zoom) {
    viewport = JSON.parse(JSON.stringify(viewport));
    bounds = bounds ? JSON.parse(JSON.stringify(bounds)) : null;
    var map = this.selectMapEngine(viewport, bounds || {}, zoom);
    if (map && map !== this.Map) {
        this.Map.deactivate();
        map.navigate(bounds || viewport, true);
        map.center = this.Map.getCenter();
        map.zoom = this.zoom;
        this.trigger("switchmap", this.Map, map);
        this.Map = map;
        this.Map.activate();
    } else if (!map) {
        Log.error("No map engine found!");
        return false;
    }
    this.unbindEventOnMap(map);
    this.bindEventOnMap(map);
    return true;
};
StoreLocator.prototype.unbindEventOnMap = function unbindEventOnMap (map) {
    this.rem_bounds_changed_ev && map.off(this.rem_bounds_changed_ev);
    this.rem_idle_ev && map.off(this.rem_idle_ev);
    this.rem_selectpoint_ev && map.off(this.rem_selectpoint_ev);
    this.rem_zoom_ev && map.off(this.rem_zoom_ev);
    this.rem_dragend_ev && map.off(this.rem_dragend_ev);
};
StoreLocator.prototype.bindEventOnMap = function bindEventOnMap (map) {
        var this$1 = this;

    this.rem_bounds_changed_ev = map.on("bounds_changed", function (e) {
        var zoom = this$1.zoom;
        
    });
    var timer;
    this.rem_idle_ev = map.on("idle", function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
            this$1.selectAndSwitchMap(map.bounds, undefined, this$1.zoom);
            this$1.trigger("moveinmap", this$1.Map);
        }, 10);
    });
    this.rem_selectpoint_ev = map.on("selectpoint", function (e, markerpoint) {
        this$1.trigger("selectpoint", map, markerpoint);
    });
    var c_zoom = this.zoom;
    this.rem_zoom_ev = map.on("zoom_changed", function () {
        this$1.trigger("mapzoom", c_zoom, map.zoom);
        c_zoom = this$1.zoom;
    });
    this.rem_dragend_ev = map.on("dragend", function () {
        this$1.trigger("mappan");
    });
};
StoreLocator.prototype.getMarker = function getMarker (code) {
    return this.Map.getMarker(code);
};
StoreLocator.prototype.showPoint = function showPoint (points, use_cluster) {
        var this$1 = this;

    return new Promise(function (resolve, reject) {
        var mrks = this$1.Map.showMarker(points, use_cluster);
        resolve(mrks);
    });
};
prototypeAccessors.zoom.get = function () {
    return this._zoom = this.Map.zoom;
};
prototypeAccessors.zoom.set = function (delta) {
    this.Map.zoom = this._zoom + delta;
    this._zoom = this.Map.zoom;
};
StoreLocator.prototype.addMapEngine = function addMapEngine (name, engine) {
    this.MapsEngines[name] = engine;
    if (!this.Map) {
        Log.warn("No default Map engine found, select the first one");
        this.Map = engine;
        this.Map.activate();
    }
};
StoreLocator.prototype.removeMapEngine = function removeMapEngine (name) {
    var engine = this.MapsEngines[name];
    if (this.Map === engine) {
        this.Map = null;
    }
    delete this.MapsEngines[name];
};
StoreLocator.prototype.addSearchEngine = function addSearchEngine (name, engine) {
    this.SearchEngines[name] = engine;
};
StoreLocator.prototype.removeSearchEngine = function removeSearchEngine (name) {
    delete this.SearchEngines[name];
};
StoreLocator.prototype.on = function on (ev, fn) {
    $(this).on(ev, fn);
    return this;
};
StoreLocator.prototype.off = function off (ev, fn) {
    $(this).off(ev, fn);
    return this;
};
StoreLocator.prototype.trigger = function trigger (ev) {
        var args = [], len = arguments.length - 1;
        while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

    var $t = $(this);
    $t.trigger.call($t, ev, args);
    return this;
};

Object.defineProperties( StoreLocator.prototype, prototypeAccessors );

return StoreLocator;

})));
